"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.Services = void 0;
exports.handleGenericError = handleGenericError;
var tslib_1 = require("tslib");
var notification_service_1 = require("../components/notification.toast/notification.service");
var index_1 = require("../i18n/index");
var license_service_1 = require("../services/license.service");
var analytics_service_1 = require("./analytics.service");
var collection_service_1 = require("./collection.service");
var config_service_1 = require("./config.service");
var dashboard_service_1 = require("./dashboard.service");
var date_time_service_1 = require("./date.time.service");
var department_service_1 = require("./department.service");
var download_service_1 = require("./download.service");
var draw_state_service_1 = require("./draw.state.service");
var export_service_1 = require("./export.service");
var focus_away_service_1 = require("./focus.away.service");
var form_service_1 = require("./form.service");
var geocoder_service_1 = require("./geocoder.service");
var ike_rest_service_1 = require("./ike.rest.service");
var input_service_1 = require("./input/input.service");
var log_service_1 = require("./log.service");
var map_service_1 = require("./map.service");
var measurement_service_1 = require("./measurement.service");
var multi_list_search_service_1 = require("./multi.list.search.service");
var observable_storage_1 = require("./observable.storage");
var render_service_1 = require("./render.service");
var route_service_1 = require("./route.service");
var search_org_service_1 = require("./search.org.service");
var search_service_1 = require("./search.service");
var sso_service_1 = require("./sso.service");
var streetview_service_1 = require("./streetview.service");
var subform_link_service_1 = require("./subform.link/subform.link.service");
var tag_service_1 = require("./tag.service");
var token_service_1 = require("./token.service");
var user_profile_service_1 = require("./user.profile.service");
var user_service_1 = require("./user.service");
var user_settings_service_1 = require("./user.settings.service");
var window_service_1 = require("./window.service");
function handleGenericError(e) {
    notification_service_1.NotificationService.error({
        key: index_1.T.ERROR_GENERAL
    });
    return null;
}
var ServiceRegistry = /** @class */ (function () {
    function ServiceRegistry(Analytics, Collection, Config, SSO, DateTime, Department, Download, DrawState, Export, FocusAway, Form, Geocoder, Input, LocalStorage, Log, Map, Measurement, Render, Rest, Route, SearchOrg, Dashboard, MultiListSearch, Search, Streetview, SubFormLink, Tag, Token, User, UserProfile, UserSettings, Window, License) {
        if (Analytics === void 0) { Analytics = new analytics_service_1.AnalyticsService(); }
        if (Collection === void 0) { Collection = new collection_service_1.CollectionService(); }
        if (Config === void 0) { Config = new config_service_1.ConfigService(); }
        if (SSO === void 0) { SSO = new sso_service_1.SSOService(); }
        if (DateTime === void 0) { DateTime = new date_time_service_1.DateTimeService(); }
        if (Department === void 0) { Department = new department_service_1.DepartmentService(log_service_1.Logger); }
        if (Download === void 0) { Download = new download_service_1.DownloadService(); }
        if (DrawState === void 0) { DrawState = new draw_state_service_1.DrawStateService(log_service_1.Logger); }
        if (Export === void 0) { Export = new export_service_1.ExportService(); }
        if (FocusAway === void 0) { FocusAway = new focus_away_service_1.FocusAwayService(); }
        if (Form === void 0) { Form = new form_service_1.FormService(); }
        if (Geocoder === void 0) { Geocoder = new geocoder_service_1.GeocoderService(); }
        if (Input === void 0) { Input = new input_service_1.InputService(); }
        if (LocalStorage === void 0) { LocalStorage = observable_storage_1.LocalStorage; }
        if (Log === void 0) { Log = new log_service_1.LogService(); }
        if (Map === void 0) { Map = new map_service_1.MapService(); }
        if (Measurement === void 0) { Measurement = new measurement_service_1.MeasurementService(); }
        if (Render === void 0) { Render = new render_service_1.RenderService(); }
        if (Rest === void 0) { Rest = new ike_rest_service_1.IkeRestService(); }
        if (Route === void 0) { Route = new route_service_1.RouteService(); }
        if (SearchOrg === void 0) { SearchOrg = new search_org_service_1.SearchOrgService(); }
        if (Dashboard === void 0) { Dashboard = new dashboard_service_1.DashboardService(); }
        if (MultiListSearch === void 0) { MultiListSearch = new multi_list_search_service_1.MultiListSearchService(); }
        if (Search === void 0) { Search = new search_service_1.SearchService(); }
        if (Streetview === void 0) { Streetview = new streetview_service_1.StreetviewService(); }
        if (SubFormLink === void 0) { SubFormLink = new subform_link_service_1.SubFormLinkService(); }
        if (Tag === void 0) { Tag = new tag_service_1.TagService(); }
        if (Token === void 0) { Token = new token_service_1.TokenService(); }
        if (User === void 0) { User = new user_service_1.SSOUserService(); }
        if (UserProfile === void 0) { UserProfile = new user_profile_service_1.UserProfileService(log_service_1.Logger); }
        if (UserSettings === void 0) { UserSettings = new user_settings_service_1.UserSettingsService(); }
        if (Window === void 0) { Window = new window_service_1.WindowService(); }
        if (License === void 0) { License = new license_service_1.LicenseService(); }
        this.Analytics = Analytics;
        this.Collection = Collection;
        this.Config = Config;
        this.SSO = SSO;
        this.DateTime = DateTime;
        this.Department = Department;
        this.Download = Download;
        this.DrawState = DrawState;
        this.Export = Export;
        this.FocusAway = FocusAway;
        this.Form = Form;
        this.Geocoder = Geocoder;
        this.Input = Input;
        this.LocalStorage = LocalStorage;
        this.Log = Log;
        this.Map = Map;
        this.Measurement = Measurement;
        this.Render = Render;
        this.Rest = Rest;
        this.Route = Route;
        this.SearchOrg = SearchOrg;
        this.Dashboard = Dashboard;
        this.MultiListSearch = MultiListSearch;
        this.Search = Search;
        this.Streetview = Streetview;
        this.SubFormLink = SubFormLink;
        this.Tag = Tag;
        this.Token = Token;
        this.User = User;
        this.UserProfile = UserProfile;
        this.UserSettings = UserSettings;
        this.Window = Window;
        this.License = License;
    }
    ServiceRegistry.prototype.bindServices = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allServices, _a, allServices_1, allServices_1_1, service, initter, error_1, e_1_1;
            var _b, e_1, _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        allServices = Object.values(this).sort(function (a, b) { return a.__priority - b.__priority; });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 10, 11, 16]);
                        _a = true, allServices_1 = tslib_1.__asyncValues(allServices);
                        _e.label = 2;
                    case 2: return [4 /*yield*/, allServices_1.next()];
                    case 3:
                        if (!(allServices_1_1 = _e.sent(), _b = allServices_1_1.done, !_b)) return [3 /*break*/, 9];
                        _d = allServices_1_1.value;
                        _a = false;
                        service = _d;
                        if (!(typeof service.init === 'function')) return [3 /*break*/, 8];
                        _e.label = 4;
                    case 4:
                        _e.trys.push([4, 7, , 8]);
                        initter = service.init();
                        if (!(initter && typeof initter.then === 'function')) return [3 /*break*/, 6];
                        return [4 /*yield*/, initter];
                    case 5:
                        _e.sent();
                        _e.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _e.sent();
                        throw error_1;
                    case 8:
                        _a = true;
                        return [3 /*break*/, 2];
                    case 9: return [3 /*break*/, 16];
                    case 10:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 16];
                    case 11:
                        _e.trys.push([11, , 14, 15]);
                        if (!(!_a && !_b && (_c = allServices_1.return))) return [3 /*break*/, 13];
                        return [4 /*yield*/, _c.call(allServices_1)];
                    case 12:
                        _e.sent();
                        _e.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 15: return [7 /*endfinally*/];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    return ServiceRegistry;
}());
exports.Services = new ServiceRegistry();
exports.Logger = exports.Services.Log.Logger;
//# sourceMappingURL=index.js.map